import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=e956f686&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=e956f686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e956f686",
  null
  
)

export default component.exports